import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SmallHeading = styled(Typography)(({ theme }: any) => ({
  fontWeight: 600,
  color: 'title',
  [theme.breakpoints.up('xs')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '0.7rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '0.7rem !important',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1rem !important',
  },
  [theme.breakpoints.up('xxl')]: {
    fontSize: '1.1rem !important',
  },
}));
